import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import UserService from "./services/user.service";

import { Form } from "react-bootstrap"
import Alert from 'react-bootstrap/Alert'
import { login } from "./actions/auth.js";
import { logout } from "./actions/auth.js";
import { WrapperApp } from "./App.js"
import RegistroNuevoUsuario from "./Register.js";
import Dashboard from "./Dashboard.js";
import ExportSidebar from "./ProSideBar.js";

const Login = () => {

  const { control, handleSubmit, formState: { errors },} = useForm({
    defaultValues: {
      username: "",
      password: ""
    },
  });  

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const { isLoggedIn } = useSelector(state => state.auth);
  //const { user } = useSelector(state => state.auth);
  const [user, setUser] = useState("");

  
  useEffect(() => {
    
    UserService.getUserBoard()
    .then( // note that getUserBoard from user.service.js is used here and login from auth.service.js is used on Login
      (response) => { 
        setUser(response.data);
      }
    )
    .catch((e) => {
      if (e.response.status == 401) {
        dispatch(logout())
        .then(() => {
          window.location.reload();
        })
        .catch(() => {

        });
      }
      console.log(e.response.status);   
    });    
  }, []);
  

  const { message } = useSelector(state => state.message);

  const dispatch = useDispatch();

  const onChangeUsername = (e) => {  
    //console.log(e.target.value);
    const username = e.target.value;
    setUsername(username);
  };

  const onChangePassword = (e) => {
    const password = e.target.value;
    setPassword(password);
  };

  const handleLogin = (e) => {    
    setLoading(true);
    
    if (!loading) {
      dispatch(login(e.username, e.password))
        .then(() => {
          //window.location.reload();
          window.location.assign("/dashboard"); //better than reload
        })
        .catch(() => {
          setLoading(false);
        });
    } 
    else {
      setLoading(false);
    }
  };

  if (isLoggedIn) { 
    //window.location.reload();
    //return <Navigate to="/" />;
    return (
      <>
      <WrapperApp user={user}/>
      </>
      
    ) 
  };

  return (
    <>
    <div className="col-md-12">
      <div className='m-2' style={{textAlign:'center'}}>
        <img src="./logo512.png" width={"120px"}/>
        <div>Hola!</div>
        <div>Bienvenido a la app de registro de jueces para la liga Cantabria</div>
        <div>Inicia sesión para continuar</div>
      </div>
      <div className="col-md-12"></div>
      <div 
        className="card card-container"
        style={{maxWidth:'100px',padding:'40px 40px',}}>


        <Form noValidate onSubmit={handleSubmit(handleLogin)}>
          <div className="form-group">
            <label className="m-2" htmlFor="username">Usuario</label>
            <Controller
              name="username"
              control={control}
              onChange={onChangeUsername}
              rules={{ required: true }}
              render={({ field }) => (
                <Form.Control
                  {...field}
                    className="m-2"
                    type="text"
                    isInvalid={errors.username}
                    //onChange={onChangeUsername}
                    //value={username}
                    
                />
              )}
            />
            {errors.username && (
              <Form.Control.Feedback type="invalid">
                Se requiere un usuario
              </Form.Control.Feedback>
            )}          
          </div>
          <div className="form-group">
            <label className="m-2" htmlFor="password">Contraseña</label>
            <Controller
              name="password"
              control={control}
              onChange={onChangePassword}
              rules={{ required: true }}              
              render={({ field }) => (
                <Form.Control
                  {...field}
                    className="m-2"
                    type="password"
                    isInvalid={errors.password}
                    //onChange={onChangePassword}
                    //value={password}
                />
              )}
            />
            {errors.password && (
              <Form.Control.Feedback type="invalid">
                Se requiere una contraseña
              </Form.Control.Feedback>
            )}
          </div>  

          <div className="form-group">
            <button className="btn btn-primary btn-block" disabled={loading}>
              {loading && (
                <span className="spinner-border spinner-border-sm"></span>
              )}
              <span>Login</span>
            </button>
          </div>

          {message && (
            <div className="form-group">
              <div className="alert alert-danger" role="alert">
                {message}
              </div>
            </div>
          )}
          <hr />
          <span style={{fontSize:'14px'}} >
            ¿Aun no tienes una cuenta? Crea una <a href="/auto-register">aquí</a>.
          </span>
        </Form>
      </div>
    </div>
    </>
  );
};

export default Login;